import { FormField, Select, SelectOption } from "@justworkshr/milo-form";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { SchemaType } from "./config";
import { fieldErrorHandler } from "../../../forms/utils/fieldErrorHandler";

export default function FormFragment() {
  const { t } = useTranslation();
  const { errors, touched, handleBlur, values, handleChange } =
    useFormikContext<SchemaType>();

  return (
    <>
      <FormField
        required
        name="probationPeriodDays"
        label={t("Probation Period")}
        error={fieldErrorHandler("probationPeriodDays", errors, touched)}
      >
        <Select
          name="probationPeriodDays"
          placeholder={t("Select probation period days")}
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.probationPeriodDays}
        >
          <SelectOption value="0">{t("None")}</SelectOption>
          <SelectOption value="90">{t("90 days")}</SelectOption>
        </Select>
      </FormField>
    </>
  );
}
